'use client';

import { useTranslations } from 'next-intl';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errorPage');

  console.error(error);
  return (
    <div className="w-full h-full flex flex-col justify-center items-center text-center bg-chineseBlack text-white px-2">
      <p className="text-6xl text-fanflareGray">!</p>
      <p className="text-2xl pt-3 pb-1">{t('title')}</p>
      <p className="text-fanflareGray">{t('description')}</p>
      <button
        className="bg-lightRed px-5 py-2 rounded-md text-chineseBlack my-5"
        onClick={() => reset()}
      >
        {t('refresh')}
      </button>
    </div>
  );
}
